import { aboutData } from '@/mocks/homeData';

export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100">
      <div className="section-container">
        <div className="max-w-[800px] mx-auto text-center">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950">
            关于无极电影网
          </h2>
          <p className="mt-5 md:mt-6 text-sm md:text-base text-foreground-600 leading-relaxed">
            {aboutData.description}
          </p>

          <div className="mt-8 md:mt-10 grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
            {aboutData.highlights.map((item) => (
              <div
                key={item.label}
                className="bg-background-50 rounded-xl border border-background-200/60 p-4 md:p-5"
              >
                <p className="text-2xl md:text-3xl font-heading font-bold text-primary-500">{item.value}</p>
                <p className="mt-1 text-xs md:text-sm text-foreground-500">{item.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}